// @ts-nocheck
import { debugLog } from '../../lib/debug-log';
import { isValid } from '@cloud20x/vin-decoder';

export const identifyVinNumber = (vinNumber: any) => {
  if (!vinNumber) return null;

  let sanitizedVin = vinNumber.replace('WIN', 'W1N');

  sanitizedVin = sanitizedVin.replaceAll(/[^a-zA-Z0-9]/g, '');
  sanitizedVin = sanitizedVin.replaceAll('O','0').replaceAll('o','0');
  sanitizedVin = sanitizedVin.replaceAll('Q','0').replaceAll('q','0');
  sanitizedVin = sanitizedVin.replaceAll('I','1').replaceAll('i','1');
  sanitizedVin = sanitizedVin.slice(0, 17);

  debugLog({ vinNumber, sanitizedVin });

  if (!isValid(sanitizedVin)) return null;

  return sanitizedVin;
};
